<ng-container *featureVisibility="featureList.STAKING_GLOBAL">
  @if (stakedAsset.availability !== availabilityStates.DISABLED) {
    <button
      class="btn btn-primary btn-staking-details"
      (click)="clickFlow('stake', stakedAsset)"
      [ngClass]="{ unclickable: stakedAsset.availability === availabilityStates.SOLD_OUT }"
		[bp-tooltip]="
			stakedAsset.availability === availabilityStates.SOLD_OUT
				? ('staking_sold_out_banner_text' | translate: [stakedAsset.name])
				: ''
		">
      <span class="text-overflow-ellipsis block">{{ "stake_more" | translate }}</span>
    </button>
  }
</ng-container>
@if (+stakedAsset.stakedAmount > 0) {
  <button
    class="btn btn-primary btn-inverse btn-staking-details"
    (click)="clickFlow('unstake', stakedAsset)">
    <span class="text-overflow-ellipsis block">{{ "unstake" | translate }}</span>
  </button>
}
